import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import moment from 'moment'
import 'react-dates/initialize'
import { DateRangePicker } from 'react-dates'
import 'react-dates/lib/css/_datepicker.css'
import MediaQuery from 'react-responsive'
import NumberFormat from 'react-number-format'
import HtmlEditor from '../../Components/Commons/HtmlEditor'
import { renderFiles, renderPDFFiles, renderImageFiles, renderOfficeFiles, renderVideoFiles } from '../Commons/Utils'

import { DatePicker } from 'antd'

const dateFormat = 'YYYY-MM-DD'

function getTodayDate() {
    const date = new Date()
    const year = date.getFullYear()
    const month = ('0' + (1 + date.getMonth())).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)

    return year + '-' + month + '-' + day
}

const todayDate = getTodayDate()

class ResultForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            input: {
                price: '',
                content: '',
                status: 'OPEN',
            },
            startDate: null,
            endDate: null,
            demand: null,
            disabled: false,
        }
    }

    UNSAFE_componentWillMount() {
        this.setState({
            demand: this.props.demand,
            disabled: true,
        })
    }

    addResult = () => {
        if (this.state.input.content === '') {
            alert('내용을 입력해주세요.')
            return
        } else if (this.state.startDate === null) {
            alert('시작일을 선택해주세요')
            return
        } else if (this.state.endDate === null) {
            alert('마감일을 선택해주세요')
            return
        }

        const { cookies } = this.props

        let price = ''
        if (this.state.input.price === '') {
            price = 0
        } else {
            price = this.state.input.price
        }

        console.log(this.state.demand)
        if (this.state.demand.response) {
            axios
                .patch(
                    `${BACKEND_HOST}/rfis/${this.props.id}/response`,
                    {
                        changedPrice: Number(price.toString().replace(/,/g, '')),
                        changedPeriod: {
                            startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
                            endDate: moment(this.state.endDate).format('YYYY-MM-DD'),
                        },
                        content: this.state.input.content,
                        status: this.state.input.status,
                    },
                    {
                        headers: {
                            Authorization: `bearer ${Auth.getToken()}`,
                        },
                    }
                )
                .then((res) => {
                    console.log(res.data)
                    this.props.history.push(`/demand/`)
                    // this.setState({
                    //     demand: res.data,
                    //     disabled: true,
                    // })
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            axios
                .post(
                    `${BACKEND_HOST}/rfis/${this.props.id}/response`,
                    {
                        changedPrice: Number(price.toString().replace(/,/g, '')),
                        changedPeriod: {
                            startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
                            endDate: moment(this.state.endDate).format('YYYY-MM-DD'),
                        },
                        content: this.state.input.content,
                        status: this.state.input.status,
                    },
                    {
                        headers: {
                            Authorization: `bearer ${Auth.getToken()}`,
                        },
                    }
                )
                .then((res) => {
                    // console.log(res.data)
                    this.props.history.push(`/demand/`)
                    // this.setState({
                    //     demand: res.data,
                    //     disabled: true,
                    // })
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    completeResult = () => {
        const confirmText = confirm('완료처리 이후 수정이 불가합니다.')

        if (confirmText) {
            alert('완료처리 되었습니다.')
        } else {
            return
        }

        const { cookies } = this.props
        axios
            .patch(
                `${BACKEND_HOST}/rfis/${this.props.id}/response`,
                {
                    status: 'CLOSE',
                },
                {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                this.props.history.push(`/demand/`)
                // console.log(res.data)
                // this.setState({
                //     demand: res.data,
                // })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clickModify = () => {
        //날짜 입력
        const newYear = this.state.demand.response.changedPeriod.startDate.substring(0, 4)
        const newMonth = this.state.demand.response.changedPeriod.startDate.substring(5, 7)
        const newDay = this.state.demand.response.changedPeriod.startDate.substring(8, 10)

        const newYear2 = this.state.demand.response.changedPeriod.endDate.substring(0, 4)
        const newMonth2 = this.state.demand.response.changedPeriod.endDate.substring(5, 7)
        const newDay2 = this.state.demand.response.changedPeriod.endDate.substring(8, 10)

        this.setState({
            disabled: false,
            input: {
                price: this.state.demand.response.changedPrice,
                content: this.state.demand.response.content,
                status: this.state.demand.status,
            },
            startDate: moment(`${newYear}-${newMonth}-${newDay}`),
            endDate: moment(`${newYear2}-${newMonth2}-${newDay2}`),
        })
    }

    closeResult = () => {
        this.setState({
            disabled: true,
        })
    }

    changeData = (event) => {
        const field = event.target.name
        const input = this.state.input
        input[field] = event.target.value

        this.setState({
            input,
        })
    }

    handleModelChange = (model) => {
        const input = this.state.input
        input['content'] = model

        this.setState({
            input,
        })
    }

    handleChangeDate = ({ startDate, endDate }) => {
        this.setState({
            startDate,
            endDate,
        })
    }

    handleChangeStartDate = (startDate) => {
        this.setState({
            startDate,
        })
    }

    handleChangeEndDate = (endDate) => {
        this.setState({
            endDate,
        })
    }

    Comma = (num) => {
        if (typeof num === 'number') {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
            return ''
        }
    }

    render() {
        if (this.state.disabled && this.state.demand.response.createdAt) {
            //날짜 변환
            let changeDate = ''
            if (
                this.state.demand.response.changedPeriod &&
                this.state.demand.response.changedPeriod.startDate &&
                this.state.demand.response.changedPeriod.endDate
            ) {
                const newDate = new Date(this.state.demand.response.changedPeriod.startDate)
                const newYear = newDate.getFullYear()

                let newMonth = newDate.getMonth() + 1
                if (newMonth < 10) {
                    newMonth = '0' + newMonth
                }
                let newDay = newDate.getDate()
                if (newDay < 10) {
                    newDay = '0' + newDay
                }

                const newDate2 = new Date(this.state.demand.response.changedPeriod.endDate)
                const newYear2 = newDate2.getFullYear()

                let newMonth2 = newDate2.getMonth() + 1
                if (newMonth2 < 10) {
                    newMonth2 = '0' + newMonth2
                }
                let newDay2 = newDate2.getDate()
                if (newDay2 < 10) {
                    newDay2 = '0' + newDay2
                }

                changeDate = `${newYear}.${newMonth}.${newDay} → ${newYear2}.${newMonth2}.${newDay2}`
            }

            const newDate3 = new Date(this.state.demand.updatedAt)
            const newYear3 = newDate3.getFullYear()

            let newMonth3 = newDate3.getMonth() + 1
            if (newMonth3 < 10) {
                newMonth3 = '0' + newMonth3
            }
            let newDay3 = newDate3.getDate()
            if (newDay3 < 10) {
                newDay3 = '0' + newDay3
            }
            let newHours = newDate3.getHours()
            if (newHours < 10) {
                newHours = '0' + newHours
            }
            let newMinutes = newDate3.getMinutes()
            if (newMinutes < 10) {
                newMinutes = '0' + newMinutes
            }

            let status = ''
            if (this.state.demand.status === 'HOLD') {
                status = 'status_r'
            } else if (this.state.demand.status === 'OPEN') {
                status = 'status_y'
            } else {
                status = 'status_g'
            }

            return (
                <div className="result_wrap">
                    <div className="auth_writer">담당자</div>
                    <h1>담당자 처리내용</h1>
                    <div className="result_detail_wrap">
                        <ul className="info_wrap">
                            <li>
                                <p className="label">상태</p>
                                <div className={status + ' content status'}>{this.state.demand.status}</div>
                            </li>
                            <li>
                                <p className="label">요청사항 비용</p>
                                <p className="content price">
                                    {this.Comma(this.state.demand.response.changedPrice)}
                                    <span>원</span>
                                </p>
                            </li>
                            <li>
                                <p className="label">요청사항 처리 기간</p>
                                <div className="content date">{changeDate}</div>
                            </li>
                        </ul>
                        <p className="textarea_wrap">
                            <div
                                className="inner_html"
                                dangerouslySetInnerHTML={{ __html: this.state.demand.response.content }}></div>
                        </p>
                        {this.state.demand.response.files.length !== 0 && (
                            <div className="text_wrap">
                                <div className="content">{renderFiles(this.state.demand.response.files)}</div>
                            </div>
                        )}
                        {this.state.demand.response.files.length !== 0 &&
                            renderPDFFiles(this.state.demand.response.files)}
                        {this.state.demand.response.files.length !== 0 &&
                            renderOfficeFiles(this.state.demand.response.files)}
                        {this.state.demand.response.files.length !== 0 &&
                            renderImageFiles(this.state.demand.response.files)}
                        {this.state.demand.response.files.length !== 0 &&
                            renderVideoFiles(this.state.demand.response.files)}
                        <div className="writer">
                            {this.state.demand.assignee.name} {newYear3}.{newMonth3}.{newDay3}.{newHours}:{newMinutes}
                        </div>
                        {/* {this.props.user._id === this.state.demand.assignee._id &&
                            this.state.demand.status !== 'CLOSE' && (
                                <div className="btn_wrap">
                                    <div className="green_line_btn" onClick={this.completeResult}>
                                        완료처리
                                    </div>
                                    <div className="ok_btn" onClick={this.clickModify}>
                                        수정
                                    </div>
                                </div>
                            )} */}
                    </div>
                </div>
            )
        } else {
            return (
                <div className="result_wrap">
                    <div className="auth_writer">담당자</div>
                    <h1>담당자 처리내용</h1>
                    <div className="result_write_wrap">
                        <div className="status_wrap">
                            <p>상태 선택</p>
                            <ul className="status_list">
                                <li>
                                    <input
                                        id="progress"
                                        type="radio"
                                        name="status"
                                        value="OPEN"
                                        onChange={this.changeData}
                                        checked={this.state.input.status === 'OPEN' && true}
                                    />
                                    <label htmlFor="progress">OPEN</label>
                                </li>
                                <li>
                                    <input
                                        id="complete"
                                        type="radio"
                                        name="status"
                                        value="CLOSE"
                                        onChange={this.changeData}
                                        checked={this.state.input.status === 'CLOSE' && true}
                                    />
                                    <label htmlFor="complete">CLOSE</label>
                                </li>
                                <li>
                                    <input
                                        id="return"
                                        type="radio"
                                        name="status"
                                        value="HOLD"
                                        onChange={this.changeData}
                                        checked={this.state.input.status === 'HOLD' && true}
                                    />
                                    <label htmlFor="return">HOLD</label>
                                </li>
                            </ul>
                        </div>
                        <ul className="input_wrap">
                            <li className="input_li">
                                <label htmlFor="price">요청사항 비용</label>
                                <NumberFormat
                                    className="input"
                                    type="text"
                                    thousandSeparator={true}
                                    placeholder="금액을 입력하세요 (ex. 2,000,000)"
                                    id="price"
                                    name="price"
                                    onChange={this.changeData}
                                    value={this.state.input.price}
                                />
                                <p className="unit">원</p>
                            </li>
                            <li className="input_li">
                                <label>요청사항 처리 기간</label>
                                <div className="date_picker">
                                    <MediaQuery maxWidth={768}>
                                        {(matches) => {
                                            if (matches) {
                                                return (
                                                    <>
                                                        <DatePicker
                                                            disabledDate={(d) => {
                                                                return !d || d.isAfter(this.state.endDate, 'day')
                                                            }}
                                                            style={{ height: 38, width: '47.5%', marginRight: '5%' }}
                                                            placeholder="시작일"
                                                            onChange={(date, dateString) => {
                                                                this.handleChangeStartDate(date)
                                                            }}
                                                            value={this.state.startDate}
                                                            format={dateFormat}
                                                        />

                                                        <DatePicker
                                                            disabledDate={(d) =>
                                                                !d || d.isBefore(this.state.startDate, 'day')
                                                            }
                                                            style={{ height: 38, width: '47.5%' }}
                                                            placeholder="종료일"
                                                            onChange={(date, dateString) => {
                                                                this.handleChangeEndDate(date)
                                                            }}
                                                            value={this.state.endDate}
                                                            format={dateFormat}
                                                        />
                                                    </>
                                                )
                                            } else {
                                                return (
                                                    <>
                                                        <DatePicker
                                                            disabledDate={(d) => {
                                                                return !d || d.isAfter(this.state.endDate, 'day')
                                                            }}
                                                            style={{ height: 38, width: '47.5%', marginRight: '5%' }}
                                                            placeholder="시작일"
                                                            onChange={(date, dateString) => {
                                                                this.handleChangeStartDate(date)
                                                            }}
                                                            value={this.state.startDate}
                                                            format={dateFormat}
                                                        />

                                                        <DatePicker
                                                            disabledDate={(d) =>
                                                                !d || d.isBefore(this.state.startDate, 'day')
                                                            }
                                                            style={{ height: 38, width: '47.5%' }}
                                                            placeholder="종료일"
                                                            onChange={(date, dateString) => {
                                                                this.handleChangeEndDate(date)
                                                            }}
                                                            value={this.state.endDate}
                                                            format={dateFormat}
                                                        />
                                                    </>
                                                )
                                            }
                                        }}
                                    </MediaQuery>
                                </div>
                            </li>
                        </ul>
                        <div className="textarea_wrap">
                            <HtmlEditor content={this.state.input.content} handleModelChange={this.handleModelChange} />
                        </div>
                        <div className="btn_wrap">
                            <div
                                className="cancel_btn"
                                onClick={this.props.disabled === false ? this.props.closeResult : this.closeResult}>
                                취소
                            </div>
                            <div className="ok_btn" onClick={this.addResult}>
                                등록
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default withCookies(ResultForm)



// WEBPACK FOOTER //
// ./Src/Components/Demand/ResultForm.js